<article>
  <h2 class="text">We would love to hear from you!</h2>
  <div class="contacts">
    <div class="contact-card">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        <path
          d="M6.014 8.00613C6.12827 7.1024 7.30277 5.87414 8.23488 6.01043L8.23339 6.00894C9.14051 6.18132 9.85859 7.74261 10.2635 8.44465C10.5504 8.95402 10.3641 9.4701 10.0965 9.68787C9.7355 9.97883 9.17099 10.3803 9.28943 10.7834C9.5 11.5 12 14 13.2296 14.7107C13.695 14.9797 14.0325 14.2702 14.3207 13.9067C14.5301 13.6271 15.0466 13.46 15.5548 13.736C16.3138 14.178 17.0288 14.6917 17.69 15.27C18.0202 15.546 18.0977 15.9539 17.8689 16.385C17.4659 17.1443 16.3003 18.1456 15.4542 17.9421C13.9764 17.5868 8 15.27 6.08033 8.55801C5.97237 8.24048 5.99955 8.12044 6.014 8.00613Z"
          fill="#FFF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 23C10.7764 23 10.0994 22.8687 9 22.5L6.89443 23.5528C5.56462 24.2177 4 23.2507 4 21.7639V19.5C1.84655 17.492 1 15.1767 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM6 18.6303L5.36395 18.0372C3.69087 16.4772 3 14.7331 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C11.0143 21 10.552 20.911 9.63595 20.6038L8.84847 20.3397L6 21.7639V18.6303Z"
          fill="#FFF"
        />
      </svg>
      <h4 class="text">+267 76 199 359 / +267 77 697 643</h4>
    </div>
    <div class="contact-card">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="#FFF"
        viewBox="0 0 1920 1920"
      >
        <path
          d="M1920 428.266v1189.54l-464.16-580.146-88.203 70.585 468.679 585.904H83.684l468.679-585.904-88.202-70.585L0 1617.805V428.265l959.944 832.441L1920 428.266ZM1919.932 226v52.627l-959.943 832.44L.045 278.628V226h1919.887Z"
          fill-rule="evenodd"
        />
      </svg>
      <h4 class="text">info&#64;pixelpro.co.bw</h4>
    </div>
  </div>
  <h3 class="text">Or send us a quick email below</h3>
  <form [formGroup]="contactForm" (ngSubmit)="contactForm.valid && contact()">
    <div class="input-group">
      <label class="text" for="name">Name</label>
      <input type="text" pInputText formControlName="name" />
    </div>
    <div class="input-group">
      <label class="text" for="email">Email</label>
      <input type="text" pInputText formControlName="email" />
    </div>
    <div class="input-group">
      <label class="text" for="message">Message</label>
      <p-editor
        formControlName="message"
        [style]="{ height: '300px' }"
      ></p-editor>
    </div>
    <div class="input-group">
      <button class="btn" [disabled]="!contactForm.valid">Send Message</button>
    </div>
  </form>
</article>
